module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/partners.json
// module id = 600
// module chunks = 144403666349111